module.exports = __webpack_public_path__ + "static/media/LATTZOTH Image 1.5553e8ca.png";